import { pickBy } from 'lodash'

import { CUSTOM_EVENT_SURVEY_TRIGGER } from '@/config/events'
import { SURVEY_TOUCHPOINT_SUBMIT } from '@/config/constants'

import useApplication from '@/hooks/useApplication'
import useCollective from '@/hooks/useCollective'
import usePartner from '@/hooks/usePartner'

const { dispatchCustomEvent } = useApplication()
const { isCollective } = useCollective()
const { partnerId } = usePartner()

export default function useSurvey() {
  function triggerSubmittedSurvey(basket) {
    // FLEX-203 no survey for collective
    if (!isCollective.value) {
      // only send vepaNr if non default

      const { basketId, language } = basket

      const payload = pickBy(
        {
          basketId,
          language,
          touchPoint: SURVEY_TOUCHPOINT_SUBMIT,
          vepaNr: partnerId.value,
        },
        x => !!x
      )
      triggerSurvey(payload)
    }
  }

  function triggerSurvey(payload) {
    dispatchCustomEvent(CUSTOM_EVENT_SURVEY_TRIGGER, payload)
  }

  return {
    triggerSubmittedSurvey,
    triggerSurvey,
  }
}
